// extracted by mini-css-extract-plugin
export default {"container":"folder_list-module__container--3bbYe"};